/* JsonComparator.js */

'use strict';
let _nodeStatus = {
  IN_PROCESS: 'in_process',
  DONE: 'done'
};

const OLDVAL_STR = 'oldVal';
const NEWVAL_STR = 'newVal';
const INDEX_STR = '_idx_';
let diff;
let _;
let log;

function JsonComparator(firstJson, secondJson) {
  this.setFirstJson(firstJson);
  this.setSecondJson(secondJson);
}

JsonComparator.initialize = function (jsonDiffRef, lodash, logRef) {
  diff = jsonDiffRef;
  _ = lodash;
  log = logRef;
}

JsonComparator.prototype.setFirstJson = function (newJson) {
  if (this.firstJson !== newJson) {
    this.firstJson = newJson;
    this.cyclesInJson1 = JsonComparator._detectCycle(newJson);
    this._firstJsonWithoutCircularRefs = JsonComparator._replaceCircularRefs(this.firstJson, this.cyclesInJson1);
  }
}

JsonComparator.prototype.setSecondJson = function (newJson) {
  if (this.secondJson !== newJson) {
    this.secondJson = newJson;
    this.cyclesInJson2 = JsonComparator._detectCycle(newJson);
    this._secondJsonWithoutCircularRefs = JsonComparator._replaceCircularRefs(this.secondJson, this.cyclesInJson2);
  }
}

JsonComparator.prototype.compare = function (differencesByType) {
  return JsonComparator._compare(this._firstJsonWithoutCircularRefs, this._secondJsonWithoutCircularRefs, this.cyclesInJson1, this.cyclesInJson2, differencesByType);
}

JsonComparator.compare = function (firstJson, secondJson, differencesByType) {
  let cyclesInJson1 = JsonComparator._detectCycle(firstJson);
  let cyclesInJson2 = JsonComparator._detectCycle(secondJson);
  let firstJsonWithoutCircularRefs = JsonComparator._replaceCircularRefs(firstJson, cyclesInJson1);
  let secondJsonWithoutCircularRefs = JsonComparator._replaceCircularRefs(secondJson, cyclesInJson2);
  return JsonComparator._compare(firstJsonWithoutCircularRefs, secondJsonWithoutCircularRefs, cyclesInJson1, cyclesInJson2, differencesByType);
}

JsonComparator._compare = function (json1, json2, cyclesInJson1, cyclesInJson2, differencesByType) {
  let differences = diff(json1, json2);
  //log.debug("json differences from deep-diff: " + JSON.stringify(differences, null, "  "));
  let result = {};

  if (!differences) {
    return result;
  }
  differences.forEach(function (currentDifference) { //, index, differencesList) {
    let path = _.clone(currentDifference.path);
    path = !path ? [] : path;
    let change = {};
    if (currentDifference.kind === 'N') {
      path.splice(0, 0, 'added');
      change.newVal = currentDifference.rhs;
    } else if (currentDifference.kind === 'E') {
      // look for cyclic refs here
      let probableCyclicPath = _.concat('#', currentDifference.path).join('.');
      //log.debug("currentDifference.path: " + util.stringify(currentDifference.path));
      if (cyclesInJson1 && cyclesInJson1[probableCyclicPath]) {
        log.debug("cyclesInJson1.probableCyclicPath for path " + JSON.stringify(probableCyclicPath) + 'is: ' + JSON.stringify(cyclesInJson1[probableCyclicPath]));
      }
      let differencesFound = cyclesInJson1 && cyclesInJson1[probableCyclicPath] ? cyclesInJson1[probableCyclicPath] !== cyclesInJson2[probableCyclicPath] : true;
      if (differencesFound) {
        path.splice(0, 0, 'updated');
        change.oldVal = currentDifference.lhs;
        change.newVal = currentDifference.rhs;
      } else {
        path = [];
      }
      /*let cyclicRefDifferenceFound = true	;
            //future improvement
            if(cyclesInJson1.probableCyclicPath && cyclesInJson1.probableCyclicPath === cyclesInJson2.probableCyclicPath) {
                cyclicRefDifferenceFound = false;
                //if differencesList contains probableCyclicPath
                for(let index=0; index<differencesList.length&&!cyclicRefDifferenceFound; index++) {
                    let difference = differencesList[index];
                    cyclicRefDifferenceFound = _.isEqual(currentDifference.path, cyclesInJson1.probableCyclicPath);
                });
            }
            if(cyclicRefDifferenceFound) {
                path.splice(0, 0, 'updated');
                change.oldVal = currentDifference.lhs;
                change.newVal = currentDifference.rhs;
            }*/
    } else if (currentDifference.kind === 'D') {
      path.splice(0, 0, 'removed');
      change.oldVal = currentDifference.lhs;
    } else if (currentDifference.kind === 'A') {
      //handle new/deleted items in arrays
      if (currentDifference.item.kind === "N") {
        path.splice(0, 0, 'added');
        change = {newVal: currentDifference.item.rhs};
      }
      if (currentDifference.item.kind === "D") {
        path.splice(0, 0, 'removed');
        change.oldVal = currentDifference.item.lhs;
      }
      path.push('_idx_' + currentDifference.index);
    }
    JsonComparator._addDifferenceToResultObj(result, change, path, differencesByType);
  });
  return result;
}

JsonComparator.calculateAndPrintDifferences = function (firstJson, secondJson) {
  let differences = JsonComparator.compare(firstJson, secondJson, false);
  //log.debug('differences: ' + JSON.stringify(differences, null, 2));
  return JsonComparator.printDifferences(differences);
}

JsonComparator.printDifferences = function (differences) {
  let mergedDifferences = differences;
  if (_.has(differences, 'updated') || _.has(differences, 'added') || _.has(differences, 'removed')) {
    mergedDifferences = JsonComparator._mergeDifferences(differences);
  }
  if (_.has(mergedDifferences, NEWVAL_STR) || _.has(mergedDifferences, OLDVAL_STR)) {
    let currentDifferenceStr = JsonComparator._printDifference({path: [], val: mergedDifferences});
    return [currentDifferenceStr];
  }

  let stack = [{path: [], val: mergedDifferences}];
  let differencesArray = [];
  while (!_.isEmpty(stack)) {
    let currentElem = stack.pop();
//        log.info('currentElem: ' + JSON.stringify(currentElem));
    let currentPath = currentElem.path;
    //let newPath = currentPath;
    if (!_.isEmpty(currentPath)) {
      let lastIndexOfPath = currentPath.length - 1;
      if (currentPath[lastIndexOfPath].startsWith(INDEX_STR)) { // if array element is removed or any property in an array element.. please ignore changes below it
        currentPath[lastIndexOfPath] = currentPath[lastIndexOfPath].substring(INDEX_STR.length);
      }
    }
    if (_.has(currentElem.val, NEWVAL_STR) || _.has(currentElem.val, OLDVAL_STR)) {
      let currentDifferenceStr = JsonComparator._printDifference(currentElem);
      differencesArray.push(currentDifferenceStr);
    } else {
      for (let key in currentElem.val) {
        if (key === '__type') {
          continue;
        }
//        	log.info("currentPath: " + JSON.stringify(currentPath));
        let keyFullPath = currentPath.concat(key);
        //log.info("pushing new elem onto stack: " + JSON.stringify({path: keyFullPath, val: currentElem.val[key]}));
        stack.push({path: keyFullPath, val: currentElem.val[key]});
      }
    }
  }
  return differencesArray;
}

JsonComparator._mergeDifferences = function (differences) {
  let merged = _.merge({}, _.get(differences, 'added'), _.get(differences, 'updated'), _.get(differences, 'removed'));
  return merged;
}

JsonComparator._printDifference = function (currentElem) {
  let currentVal = currentElem.val;
  let newVal = _.get(currentVal, NEWVAL_STR, undefined);
  newVal = _.isObject(newVal) ? JSON.stringify(newVal) : newVal;
  let oldVal = _.get(currentVal, OLDVAL_STR, undefined);
  oldVal = _.isObject(oldVal) ? JSON.stringify(oldVal) : oldVal;
  let currentDifferenceStr = 'WARN: Invalid Difference to Stringify';
  if (_.has(currentVal, NEWVAL_STR) && _.has(currentVal, OLDVAL_STR)) { // update
    currentDifferenceStr = '(*) ' + _.join(currentElem.path, '.') + ' : ' + oldVal + ' -> ' + newVal;
  } else if (_.has(currentVal, NEWVAL_STR)) {
    currentDifferenceStr = '(+) ' + _.join(currentElem.path, '.') + ' : ' + newVal;
  } else if (_.has(currentVal, OLDVAL_STR)) {
    currentDifferenceStr = '(-) ' + _.join(currentElem.path, '.') + ' : ' + oldVal;
  }
  return currentDifferenceStr;
}

JsonComparator._addDifferenceToResultObj = function (result, change, path, differencesByType) {
  let pathOfChange = path;
  let differencesByTypeVal = differencesByType !== undefined ? differencesByType : true;
  if (!differencesByTypeVal) {
    change.__type = path[0];
    pathOfChange = path.slice(1);
  }
  let arrayIndexInPath = JsonComparator._getIntegerIndex(pathOfChange, 0);
  if (arrayIndexInPath === -1) {
    result = (pathOfChange.length === 0) ? _.merge(result, change) : _.set(result, pathOfChange, change);
  } else {
    let transformedChange = JsonComparator._processPathWithArrayIndices(pathOfChange, arrayIndexInPath, result, change);
    _.mergeWith(result, transformedChange, JsonComparator._customizeMerge);
  }
}

JsonComparator._getIntegerIndex = function (path, startIndex) {
  let integerValIndex = -1;
  if (_.has(path, 0)) {
    for (let index = startIndex; index < path.length; index++) {
      if (integerValIndex === -1 && typeof path[index] === 'number') {
        integerValIndex = index;
      }
    }
  }
  return integerValIndex;
}

JsonComparator._processPathWithArrayIndices = function (path, arrayIndexInPath, result, change) {
  let newPath = [];
  let newChange = {};
  let prevArrayIndexInPath = -1;
  while (arrayIndexInPath !== -1) {
    //newPath[arrayIndexInPath] = newPath[arrayIndexInPath] + '';
    //arrayIndexInPath = JsonComparator._getIntegerIndex(path, arrayIndexInPath + 1);
    newPath = _.concat(newPath, path.slice(prevArrayIndexInPath + 1, arrayIndexInPath), '_idx_' + path[arrayIndexInPath]);
    _.set(newChange, newPath, {});
    prevArrayIndexInPath = arrayIndexInPath;
    arrayIndexInPath = JsonComparator._getIntegerIndex(path, arrayIndexInPath + 1);
  }
  if (prevArrayIndexInPath < path.length - 1) {
    newPath = _.concat(newPath, path.slice(prevArrayIndexInPath + 1));
    _.set(newChange, newPath, change);
  } else {
    _.merge(_.get(newChange, newPath), change);
  }
//	log.info("newPath: " + JSON.stringify(newPath));
//	log.info("newChange after merge: " + JSON.stringify(newChange));
  return newChange;
}

JsonComparator._detectCycle = function (obj) {
  if (!_.isObjectLike(obj)) {
    return;
  }
  let inputObj = {'#': _.cloneDeep(obj)};

  let workingStack = []; // these hold paths of input object children/descendants
  let ancestorStack = [];
  let circularRefs = {};
  JsonComparator._pushToWorkingStack(workingStack, inputObj['#'], _nodeStatus.IN_PROCESS, ['#']);
  while (workingStack.length > 0) {
    let workingStackTop = workingStack[workingStack.length - 1];
    let ancestorStackTop = ancestorStack[ancestorStack.length - 1];

    let currentNodeInProcess = _.get(inputObj, workingStackTop);

    // log.debug('working stack: ' + JSON.stringify(workingStack));
    // log.debug('ancestor stack: ' + JSON.stringify(ancestorStack));
    // log.debug('working stack top: ' + JSON.stringify(workingStackTop));
    // log.debug('ancestor stack top: ' + JSON.stringify(ancestorStackTop));
    // log.debug('current node in review: ' + JSON.stringify(currentNodeInProcess));
    if (_.isEqual(workingStackTop, ancestorStackTop)) {
      workingStack.pop();
      ancestorStack.pop();
      currentNodeInProcess.__visited = _nodeStatus.DONE;
      //currentPath.pop();
    } else {
      if (_.isObjectLike(currentNodeInProcess)) {
        ancestorStack.push(workingStackTop);
        //currentPath.push()
        Object.keys(currentNodeInProcess).forEach(function (childKey) { //, index) {
          //these keys are used for object traversal
          if (childKey !== '__visited' && childKey !== '__path') {
            let currentChildInReview = currentNodeInProcess[childKey];
            if (_.isObjectLike(currentChildInReview)) {
              let currentChildPath = _.clone(workingStackTop);
              currentChildPath.push(childKey);   //workingStackTop + '.' + childKey;
              if (!_.has(currentChildInReview, '__visited')) {
                JsonComparator._pushToWorkingStack(workingStack, currentChildInReview, _nodeStatus.IN_PROCESS, currentChildPath);
              } else if (currentChildInReview.__visited === _nodeStatus.IN_PROCESS) {
                //found a circular reference
                let currentChildPathStr = _.join(currentChildPath, '.');
                circularRefs[currentChildPathStr] = _.join(currentChildInReview.__path, '.');
              }
            }
          }
        }, this);
      }
    }
  }
  // console.log("circular refs: " + JSON.stringify(circularRefs));
  return circularRefs;
}

JsonComparator.prototype._customizeMerge = function (objValue, srcValue) {
  if (_.isArray(objValue)) {
    if (objValue.index !== srcValue.index) {
      return objValue.concat(srcValue);
    } else {
      return _.merge(objValue, srcValue);
    }
  }
}

JsonComparator._pushToWorkingStack = function (workingStack, element, nodeStatus, path) {
  if (_.has(element, '__vsited')) {
    return;
  }
  element.__visited = _nodeStatus.IN_PROCESS;
  element.__path = path;
  workingStack.push(path);
}

JsonComparator.prototype.getFirstJsonWithoutCircularRefs = function () {
  return this._firstJsonWithoutCircularRefs;
}

JsonComparator.prototype.getSecondJsonWithoutCircularRefs = function () {
  return this._secondJsonWithoutCircularRefs;
}

JsonComparator.prototype.stringifyFirstJson = function () {
  return JSON.stringify(this._firstJsonWithoutCircularRefs, null, 2);
}

JsonComparator.prototype.stringifySecondJson = function () {
  return JSON.stringify(this._secondJsonWithoutCircularRefs, null, 2);
}

JsonComparator._stringifyJson = function (json, circularRefs) {
  let jsonWithCircularRefsReplaced = this._replaceCircularRefs(json, circularRefs);
  return JSON.stringify(jsonWithCircularRefsReplaced, null, 2);
}

JsonComparator._replaceCircularRefs = function (json, circularRefs) {
  if (_.isEmpty(json) || _.isEmpty(circularRefs)) {
    return json;
  }
  let jsonClone = _.clone(json);
  Object.keys(circularRefs).forEach(function (circularPath) {
    let circularRefReplacement = {
      ciruclar: true,
      '@ref': _.replace(circularRefs[circularPath], /\./g, '/')
    };
    _.set(jsonClone, circularPath.substring(2), circularRefReplacement);
  }, this);
  return jsonClone;
}

module.exports = JsonComparator;
